import styled from 'styled-components';

const StyledWork = styled.div`
  min-height: 200vh;
  width: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('../img/work2.jpg') no-repeat bottom center / cover;
  text-align: center;
  overflow: hidden;
  
  @media only screen and (max-width: 980px) {
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('../img/work2_mobile.jpg') no-repeat bottom center / cover;
  }
  
  ul {
  margin: 30px auto;
  list-style-type: none;
  padding: 0;
  }
`;

export default StyledWork;
